import { Group, Menu, Text, UnstyledButton } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';
import { ReactElement } from 'react';
import { QUEUE_FILTER_BUTTON_CLASS, QUEUE_FILTER_BUTTON_STYLE, QUEUE_FILTER_TEXT_PROPS } from './queueFilterStyle';

/**
 * One of the hub's filters: PN, Payment track, Location, Status. The same button
 * and menu as `ListRangeControl`, so the bar reads as one row of controls.
 */
export interface QueueFilterMenuProps {
  label: string;
  value: string;
  /** The first option is the default: Everyone, All, Active. */
  options: Array<{ value: string; label: string }>;
  onChange: (value: string) => void;
}

export function QueueFilterMenu({ label, value, options, onChange }: QueueFilterMenuProps): ReactElement {
  const activeLabel = options.find((option) => option.value === value)?.label ?? options[0]?.label ?? '';

  return (
    // duration 0 for the same reason as ListRangeControl: under jsdom the default
    // transition never commits the dropdown to the DOM.
    <Menu position="bottom-start" withinPortal transitionProps={{ duration: 0 }}>
      <Menu.Target>
        <UnstyledButton
          aria-label={`${label} · ${activeLabel}`}
          className={QUEUE_FILTER_BUTTON_CLASS}
          style={QUEUE_FILTER_BUTTON_STYLE}
        >
          <Group gap={6} wrap="nowrap">
            <Text {...QUEUE_FILTER_TEXT_PROPS}>{`${label} · ${activeLabel}`}</Text>
            <IconChevronDown size={11} stroke={2} color="rgba(0, 0, 0, 0.55)" />
          </Group>
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown>
        {options.map((option) => (
          <Menu.Item key={option.value} fw={option.value === value ? 600 : 400} onClick={() => onChange(option.value)}>
            {option.label}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
}
